import React, { useContext, useEffect, useState } from 'react';
import PackageTypeSelect from './packageTypeSelect';
import {
  PackageContainerTrueValidations,
  PackageContainerValidations,
  PackageDGValidations,
  PackageVehicalTrueValidations,
  PackageVehicalValidations,
  ShipmentPackageValidationValues,
  packageValidationTrueValues,
  packagesFormInitialValue,
} from '../../../initial-values';
import FreightClassField from './freighClassField';
import { isValidationValidated } from '../../../utils/helper';
import SearchDropdown from '../../global-components/searchDropdown';
import { savedPackagesList } from '../../../api/privateApis';
import DGFields from './dgFields';
import VehicalFields from './vehicalFields';
import ContainerFields from './containerFields';
import PharmaFields from './pharmaFields';
import { AbilityContext } from '../../../context/AbilityContext';

interface Props {
  packageTypeData: any;
  packagesForm: any;
  setPackagesForm: any;
  natureOfGoodsData: any;
  setPackagesList: any;
  packagesList: any;
  editPackageId: string;
  setEditPackageId: any;
  addPackageValidations: any;
  setAddPackageValidations: any;
  setIsEditPackage?: any;
}
function PackagesFields({
  natureOfGoodsData,
  packageTypeData,
  packagesForm,
  setPackagesForm,
  setPackagesList,
  packagesList,
  editPackageId,
  setEditPackageId,
  addPackageValidations,
  setAddPackageValidations,
  setIsEditPackage,
}: Props) {
  const ability = useContext(AbilityContext);
  const [validating, setValidating] = useState(false);
  const [savedPackagesOption, setSavedPackagesOptions] = useState<any>([]);
  const [showFreightField, setShowFreightField] = useState(false);
  const [containerValidations, setContainerValidations] = useState(
    PackageContainerValidations
  );
  const [vehicalValidations, setVehicalValidations] = useState(
    PackageVehicalValidations
  );
  const [dgValidations, setDGValidations] = useState(PackageDGValidations);

  const freightForArray = [
    'SKID',
    'BUNDLES',
    'CONTAINER',
    'CRATE',
    'DRUM',
    'PAIL',
    'REEL',
    'ROLLS',
    'ROLL',
    'TOTES',
    'TUBE',
    'VEHICLE',
  ];
  const handleClearButtonClick = () => {
    setPackagesForm(packagesFormInitialValue);
    setAddPackageValidations(ShipmentPackageValidationValues);
    setContainerValidations(containerValidations);
    setVehicalValidations(vehicalValidations);
    setDGValidations(dgValidations);
    setIsEditPackage(false);
    setEditPackageId('');
  };
  function addPackage() {
    setValidating(true);
    if (showFreightField && packagesForm?.freight_class === '-1') return;
    if (
      packagesForm?.is_time_sensitive &&
      (!packagesForm?.time_sensitive_hours ||
        packagesForm?.time_sensitive_hours === '')
    )
      return;
    if (
      packagesForm?.package_description === 'Vehicle' &&
      !isValidationValidated(vehicalValidations)
    )
      return;

    if (
      packagesForm?.package_description === 'Container' &&
      !isValidationValidated(containerValidations)
    )
      return;
    if (
      packagesForm?.is_dangerous_good &&
      !isValidationValidated(dgValidations)
    )
      return;
    if (isValidationValidated(addPackageValidations)) {
      setValidating(false);
      setPackagesList((prevPackagesList: any) => {
        const newPackage = { ...packagesForm };
        newPackage.id = prevPackagesList.length + 1;
        newPackage.package_id = prevPackagesList.length + 1;
        return [...prevPackagesList, newPackage];
      });
      setPackagesForm(packagesFormInitialValue);
      setAddPackageValidations(ShipmentPackageValidationValues);
    }
  }
  function handleNgValues(e: any) {
    if (e.target.value === '-1') {
      setPackagesForm({
        ...packagesForm,
        nog_id: '',
      });
      setAddPackageValidations({
        ...addPackageValidations,
        nog: false,
      });
    } else {
      let selectedId = Number(e.target.value);
      natureOfGoodsData.filter((ng: any) => {
        if (ng.nog_id === selectedId) {
          setPackagesForm({
            ...packagesForm,
            nog_id: ng.nog_id,
          });
          setAddPackageValidations({
            ...addPackageValidations,
            nog: true,
          });
        }
      });
    }
  }
  function updatePackage() {
    setValidating(true);
    if (showFreightField && packagesForm?.freight_class === '-1') return;
    if (
      packagesForm?.is_time_sensitive &&
      (!packagesForm?.time_sensitive_hours ||
        packagesForm?.time_sensitive_hours === '')
    )
      return;
    if (
      packagesForm?.package_description === 'Vehicle' &&
      !isValidationValidated(vehicalValidations)
    )
      return;

    if (
      packagesForm?.package_description === 'Container' &&
      !isValidationValidated(containerValidations)
    )
      return;
    if (
      packagesForm?.is_dangerous_good &&
      !isValidationValidated(dgValidations)
    )
      return;
    if (isValidationValidated(addPackageValidations)) {
      setValidating(false);
      setIsEditPackage(false);
      setPackagesList((prevPackagesList: any) => {
        return prevPackagesList.map((pkg: any) => {
          if (editPackageId === pkg.id) {
            setEditPackageId('');
            setPackagesForm(packagesFormInitialValue);
            setAddPackageValidations(ShipmentPackageValidationValues);
            return packagesForm;
          }
          setEditPackageId('');
          return pkg;
        });
      });
    }
  }
  function mapSelectedPackage(item: any) {
    const filteredPackage = packageTypeData.find(
      (pkg: any) => pkg.code === item.package_type
    );
    if (
      freightForArray.find(
        (item) =>
          packagesForm?.package_description.toLowerCase() === item.toLowerCase()
      )
    ) {
      setShowFreightField(true);
    } else {
      setShowFreightField(false);
    }

    if (item.package_type === 'VEHICLE') {
      setVehicalValidations(PackageVehicalTrueValidations);
    }

    if (item.package_type === 'CONTAINER') {
      setContainerValidations(PackageContainerTrueValidations);
    }

    setPackagesForm({
      ...packagesForm,
      package_type: item.package_type,
      item_id: packagesList && packagesList.length + 1,
      package_id: filteredPackage.id,
      package_description: filteredPackage.name,
      description: item.description,
      freight_class: item.freight_class_id,
      quantity: '1',
      length: item.length,
      width: item.width,
      height: item.height,
      weight: item.weight,
      is_cos: item?.is_cos,
      is_pharma: item?.is_pharma,
      time_sensitive_hours: item?.time_sensitive_hours,
      is_time_sensitive: item?.is_time_sensitive,
      un_number: item?.un_number,
      dg_neq_description: item?.dg_neq_description,
      dg_nos_description: item?.dg_nos_description,
      dg_quantity: item?.dg_quantity,
      is_nos: item?.is_nos,
      is_neq: item?.is_neq,
      proper_shipping_name: item?.proper_shipping_name,
      packing_group: item?.packing_group,
      packing_group_name: item?.packing_group_name,
      packing_type: item?.packing_type,
      packing_type_name: item?.packing_type_name,
      year: item?.year,
      make: item?.make,
      model: item?.model,
      vin: item?.vin,
      condition: item?.condition,
      anti_theft: item?.anti_theft,
      container_number: item?.container_number,
      status_name: item?.status_name,
    });
  }
  function savedPackages() {
    let payload = {
      box_type: 'NORM_BOX',
    };
    savedPackagesList(payload).then((response) => {
      if (!response?.data?.is_error) {
        let inputData = response?.data?.content?.data;
        const transformedData = inputData.map((item: any) => ({
          label: `${item.package_type} - ${item.description} - ${item.weight} x ${item.height} x ${item.width} x ${item.length}`,
          value: item,
        }));
        setSavedPackagesOptions(transformedData);
      }
    });
  }
  useEffect(() => {
    setPackagesForm({
      ...packagesForm,
      is_pharma: packagesForm?.package_description.includes('Pharma'),
      is_time_sensitive:
        !packagesForm?.package_description.includes('Pharma') && false,
    });

    if (
      packagesForm?.package_description &&
      freightForArray.find(
        (item) =>
          packagesForm?.package_description.toLowerCase() === item.toLowerCase()
      )
    ) {
      setShowFreightField(true);
    } else {
      setShowFreightField(false);
    }
  }, [packagesForm?.package_description]);

  useEffect(() => {
    savedPackages();
  }, []);

  return (
    <div>
      <div className='row'>
        <div className='col-sm-12 col-md-12'>
          <SearchDropdown
            id={'saved_packages'}
            label='Select Saved Package'
            dontShowAlreadySelected={true}
            options={savedPackagesOption && savedPackagesOption}
            onSelect={(item) => {
              if (item?.value !== '') {
                mapSelectedPackage(item.value);
                setAddPackageValidations(packageValidationTrueValues);
              }
            }}
          />
        </div>
      </div>
      <div className='text-center py-4 divider'>or</div>
      <div className='text-center'>
        <label className='mandatory-text '>
          Dimensions and Weight are Per Piece
        </label>
      </div>

      <input
        type='hidden'
        id='current_package'
        value=''
      />
      <PackageTypeSelect
        packageTypeData={packageTypeData}
        packagesForm={packagesForm}
        setPackagesForm={setPackagesForm}
      />

      <div className='row mt-4'>
        <div className='col-sm-12'>
          <label
            className='pb-2 globalInputLabel'
            htmlFor='main_description'
          >
            Description{' '}
            <span
              className='text-danger fw-bold'
              style={{ marginLeft: '4px' }}
            >
              *
            </span>
          </label>
          <input
            className={`form-control ubbe-input ${
              packagesForm?.description ? 'highlighted-border' : ''
            }`}
            id='main_description'
            placeholder='Please enter the description of the item you are shipping.'
            autoComplete='new-password'
            maxLength={40}
            value={packagesForm?.description}
            onChange={(e: any) => {
              setPackagesForm({
                ...packagesForm,
                description: e.target.value,
              });
              setAddPackageValidations({
                ...addPackageValidations,
                description: e.target.value !== '',
              });
            }}
          />
          {validating &&
            (packagesForm?.description === '' ||
              packagesForm?.description === null) && (
              <div className='error_text'>Please provide a description.</div>
            )}
        </div>
      </div>

      <div className='row mt-4'>
        <div className='col-sm-12 col-md-5 col-lg-5'>
          <label
            className='pb-2 globalInputLabel'
            htmlFor='main_quantity'
          >
            Quantity{' '}
            <span
              className='text-danger fw-bold'
              style={{ marginLeft: '3px' }}
            >
              *
            </span>
          </label>
          <input
            className={`form-control ubbe-input ${
              packagesForm?.quantity?.toString() ? 'highlighted-border' : ''
            }`}
            id='main_quantity'
            placeholder='999,999'
            autoComplete='new-password'
            maxLength={6}
            value={packagesForm?.quantity?.toString()}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              let newValue = e.target.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
              newValue =
                newValue === '' || newValue === '0'
                  ? '' // Set empty string if the input is empty or zero
                  : parseInt(newValue, 10).toString(); // Otherwise parse the value as an integer
              // Ensure minimum value is 1
              setPackagesForm({
                ...packagesForm,
                quantity: newValue,
              });
              setAddPackageValidations({
                ...addPackageValidations,
                quantity: newValue !== '', // Update the validation status
              });
            }}
          />
          {validating &&
            (packagesForm?.quantity === '' ||
              packagesForm?.quantity === null) && (
              <div className='error_text'>Please provide a quantity.</div>
            )}
        </div>

        <div className='col-sm-12 col-md-7 col-lg-7'>
          <label
            className='pb-2 globalInputLabel'
            htmlFor='main_weight'
          >
            Weight Per Piece{' '}
            <span
              className='text-danger fw-bold'
              style={{ marginLeft: '3px' }}
            >
              *
            </span>
          </label>
          <input
            className={`form-control ubbe-input ${
              packagesForm?.weight ? 'highlighted-border' : ''
            }`}
            id='main_weight'
            placeholder='999,999'
            maxLength={6}
            autoComplete='new-password'
            value={packagesForm?.weight?.toString()}
            onChange={(e: any) => {
              let newValue = e.target.value.replace(/[^0-9.]/g, ''); // Remove non-numeric and non-decimal characters
              // newValue = newValue === '' ? '' : parseFloat(newValue).toString(); // Parse the value as a float and convert it back to a string

              // If the parsed value is 0 or starts with 0 followed by a decimal, set it as an empty string
              if (newValue === '0' || newValue.startsWith('.')) {
                newValue = '';
              }
              setPackagesForm({
                ...packagesForm,
                weight: newValue,
              });
              setAddPackageValidations({
                ...addPackageValidations,
                weight: e.target.value !== '',
              });
            }}
          />
          {validating &&
            (packagesForm?.weight === '' || packagesForm?.weight === null) && (
              <div className='error_text'>Please provide a weight.</div>
            )}
        </div>
      </div>

      <div className='row mt-4'>
        <div className='col-sm-12 col-md-4 col-lg-4'>
          <label
            className='globalInputLabel pb-2'
            htmlFor='main_length'
          >
            Length{' '}
            <span
              className='text-danger fw-bold'
              style={{ marginLeft: '3px' }}
            >
              *
            </span>
          </label>
          <input
            className={`form-control ubbe-input ${
              packagesForm?.length ? 'highlighted-border' : ''
            }`}
            id='main_length'
            placeholder='999,999'
            maxLength={6}
            autoComplete='new-password'
            value={packagesForm?.length?.toString()}
            onChange={(e: any) => {
              let newValue = e.target.value.replace(/[^0-9.]/g, ''); // Remove non-numeric and non-decimal characters
              // newValue = newValue === '' ? '' : parseFloat(newValue).toString(); // Parse the value as a float and convert it back to a string

              // If the parsed value is 0 or starts with 0 followed by a decimal, set it as an empty string
              if (newValue === '0' || newValue.startsWith('.')) {
                newValue = '';
              }

              setPackagesForm({
                ...packagesForm,
                length: newValue,
              });
              setAddPackageValidations({
                ...addPackageValidations,
                length: e.target.value !== '',
              });
            }}
          />
          {validating &&
            (packagesForm?.length === '' || packagesForm?.length === null) && (
              <div className='error_text'>Please provide a length.</div>
            )}
        </div>
        <div className='col-sm-12 col-md-4 col-lg-4'>
          <label
            className='globalInputLabel pb-2'
            htmlFor='main_width'
          >
            Width{' '}
            <span
              className='text-danger fw-bold'
              style={{ marginLeft: '3px' }}
            >
              *
            </span>
          </label>
          <input
            className={`form-control ubbe-input ${
              packagesForm?.width ? 'highlighted-border' : ''
            }`}
            id='main_width'
            placeholder='999,999'
            maxLength={6}
            autoComplete='new-password'
            value={packagesForm?.width?.toString()}
            onChange={(e: any) => {
              let newValue = e.target.value.replace(/[^0-9.]/g, ''); // Remove non-numeric and non-decimal characters
              // newValue = newValue === '' ? '' : parseFloat(newValue).toString(); // Parse the value as a float and convert it back to a string

              // If the parsed value is 0 or starts with 0 followed by a decimal, set it as an empty string
              if (newValue === '0' || newValue.startsWith('.')) {
                newValue = '';
              }

              setPackagesForm({
                ...packagesForm,
                width: newValue,
              });
              // setPackagesForm({
              //   ...packagesForm,
              //   width: e.target.value.replace(/[^0-9.]|(\..*)\./g, '$1'),
              // });
              setAddPackageValidations({
                ...addPackageValidations,
                width: e.target.value !== '',
              });
            }}
          />
          {validating &&
            (packagesForm?.width === '' || packagesForm?.width === null) && (
              <div className='error_text'>Please provide a width.</div>
            )}
        </div>
        <div className='col-sm-12 col-md-4 col-lg-4'>
          <label
            className='globalInputLabel pb-2'
            htmlFor='main_height'
          >
            Height{' '}
            <span
              className='text-danger fw-bold'
              style={{ marginLeft: '3px' }}
            >
              *
            </span>
          </label>
          <input
            className={`form-control ubbe-input ${
              packagesForm?.height ? 'highlighted-border' : ''
            }`}
            id='main_height'
            placeholder='999,999'
            maxLength={6}
            autoComplete='new-password'
            value={packagesForm?.height?.toString()}
            onChange={(e: any) => {
              let newValue = e.target.value.replace(/[^0-9.]/g, ''); // Remove non-numeric and non-decimal characters
              // newValue = newValue === '' ? '' : parseFloat(newValue).toString(); // Parse the value as a float and convert it back to a string

              // If the parsed value is 0 or starts with 0 followed by a decimal, set it as an empty string
              if (newValue === '0' || newValue.startsWith('.')) {
                newValue = '';
              }
              setPackagesForm({
                ...packagesForm,
                height: newValue,
              });
              setAddPackageValidations({
                ...addPackageValidations,
                height: e.target.value !== '',
              });
            }}
          />
          {validating &&
            (packagesForm?.height === '' || packagesForm?.height === null) && (
              <div className='error_text'>Please provide a height.</div>
            )}
        </div>
      </div>

      <div className='row mt-4'>
        <div className='col-sm-12'>
          <label
            className='globalInputLabel pb-2'
            htmlFor='main_nog'
          >
            Nature of Good
            <span
              className='text-danger fw-bold'
              style={{ marginLeft: '7px' }}
            >
              *
            </span>
          </label>

          <select
            className={`form-control ubbe-input form-select  ${
              packagesForm?.nog_id ? 'highlighted-border' : ''
            }`}
            id='main_nog'
            data-width='100%'
            value={packagesForm?.nog_id}
            onChange={(e) => {
              handleNgValues(e);
            }}
            data-size='8'
          >
            <option value={'-1'}>Select a value</option>
            {natureOfGoodsData &&
              natureOfGoodsData.length > 0 &&
              natureOfGoodsData.map((option: any) => (
                <option
                  key={option.id}
                  value={option.nog_id}
                >
                  {option.nog_description}
                </option>
              ))}
          </select>
          {validating &&
            (packagesForm?.nog_id === '' || packagesForm?.nog_id === null) && (
              <div className='error_text'>Please select a Nature of Good.</div>
            )}
        </div>
      </div>
      {showFreightField && (
        <FreightClassField
          packagesForm={packagesForm}
          setPackagesForm={setPackagesForm}
          validating={validating}
        />
      )}
      {ability.can('read', 'Dangerous Goods') && (
        <>
          <div id='dg_check'>
            <div className='row mt-4'>
              <div className='col-sm-12'>
                <div className='form-check'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    checked={packagesForm?.is_dangerous_good}
                    id='is_dg'
                    onChange={(e) => {
                      setPackagesForm({
                        ...packagesForm,
                        is_dangerous_good: e.target.checked,
                      });
                    }}
                  />
                  <label
                    className='form-check-label globalInputLabel'
                    style={{ fontWeight: '300' }}
                    htmlFor='is_dg'
                  >
                    Is this Dangerous Good?
                  </label>
                </div>
              </div>
            </div>
          </div>
          {packagesForm?.is_dangerous_good && (
            <DGFields
              packagesForm={packagesForm}
              setPackagesForm={setPackagesForm}
              formValidations={dgValidations}
              setFormValidations={setDGValidations}
              validating={validating}
            />
          )}
        </>
      )}
      {packagesForm?.is_pharma && (
        <PharmaFields
          packagesForm={packagesForm}
          setPackagesForm={setPackagesForm}
          validating={validating}
        />
      )}
      {packagesForm?.package_description === 'Vehicle' && (
        <VehicalFields
          packagesForm={packagesForm}
          setPackagesForm={setPackagesForm}
          formValidations={vehicalValidations}
          setFormValidations={setVehicalValidations}
          validating={validating}
        />
      )}
      {packagesForm?.package_description === 'Container' && (
        <ContainerFields
          packagesForm={packagesForm}
          setPackagesForm={setPackagesForm}
          formValidations={containerValidations}
          setFormValidations={setContainerValidations}
          validating={validating}
        />
      )}

      <div className='row mt-4'>
        <div className='col-sm-12'>
          <div
            className='w-50 m-auto'
            id={`${editPackageId === '' ? 'add_div' : 'save_div'}`}
          >
            <p
              className='btn ubbe-blue-bg p-2 w-100 rounded-3 text-light'
              onClick={() => {
                editPackageId !== '' ? updatePackage() : addPackage();
              }}
              style={{
                width: '15%',
                backgroundColor: '#251163',
                fontFamily: 'Lexend',
              }}
            >
              {editPackageId !== '' ? 'Update Package' : '+ Add Package'}
            </p>
          </div>
          <u
            className='m-auto d-flex justify-content-center labelText'
            style={{ cursor: 'pointer' }}
            onClick={handleClearButtonClick}
          >
            {' '}
            {editPackageId !== '' ? 'Reset Changes' : 'Clear'}
          </u>
        </div>
        <div className='col-sm-6'></div>
      </div>
    </div>
  );
}

export default PackagesFields;
